import { render, staticRenderFns } from "./index.vue?vue&type=template&id=695b5c51&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=695b5c51&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b5c51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695b5c51')) {
      api.createRecord('695b5c51', component.options)
    } else {
      api.reload('695b5c51', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=695b5c51&scoped=true&", function () {
      api.rerender('695b5c51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/handing/index.vue"
export default component.exports